import {memo, ReactNode, Suspense} from 'react';

import {selectFuseCurrentLayoutConfig} from '@fuse/core/FuseSettings/fuseSettingsSlice';
import FuseSuspense from '@fuse/core/FuseSuspense';
import {styled} from '@mui/material/styles';
import {useAppSelector} from 'app/store/hooks';
import {Layout1ConfigDefaultsType} from 'app/theme-layouts/layout1/Layout1Config';
import {Outlet} from 'react-router-dom';

const Root = styled('div')(({config}: {config: Layout1ConfigDefaultsType}) => ({
  ...(config.mode === 'boxed' && {
    clipPath: 'inset(0)',
    maxWidth: `${config.containerWidth}px`,
    margin: '0 auto',
    boxShadow:
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  }),
  ...(config.mode === 'container' && {
    '& .container': {
      maxWidth: `${config.containerWidth}px`,
      width: '100%',
      margin: '0 auto',
    },
  }),
}));

type Layout1Props = {
  children?: ReactNode;
};

/**
 * The layout 1.
 */
function Layout1(props: Layout1Props) {
  const {children} = props;
  const config = useAppSelector(
    selectFuseCurrentLayoutConfig,
  ) as Layout1ConfigDefaultsType;

  return (
    <Root
      id="fuse-layout"
      config={config}
      className="flex w-full">
      <div className="flex min-w-0 flex-auto">
        <main
          id="fuse-main"
          className="relative z-10 flex min-h-full min-w-0 flex-auto flex-col">
          <div className="relative z-10 flex flex-auto flex-col bg-white">
            <FuseSuspense>
              <Outlet />
            </FuseSuspense>

            <Suspense></Suspense>
            {children}
          </div>
        </main>
      </div>
    </Root>
  );
}

export default memo(Layout1);
